import {httpsCallable} from "firebase/functions";
import {functions} from "../Security/firebase-config";
import {FUNCTION_NAMES} from "./functionNames";

function requireCallableName(name, fallback) {
  const callableName = FUNCTION_NAMES[name] || fallback;
  if (!callableName) {
    throw new Error("Live Lobby is not enabled for this environment.");
  }
  return callableName;
}

async function callLiveLobby(name, fallback, payload) {
  const callable = httpsCallable(functions, requireCallableName(name, fallback));
  const response = await callable(payload);
  return response?.data || null;
}

export async function createLiveLobby(payload) {
  return callLiveLobby("createLiveLobby", "createLiveLobbyV2", payload);
}

export async function joinLiveLobby(payload) {
  return callLiveLobby("joinLiveLobby", "joinLiveLobbyV2", payload);
}

export async function heartbeatLiveLobby(payload) {
  return callLiveLobby("heartbeatLiveLobby", "heartbeatLiveLobbyV2", payload);
}

export async function commitLiveLobbySegment(payload) {
  return callLiveLobby("commitLiveLobbySegment", "commitLiveLobbySegmentV2", payload);
}

export async function ackLiveLobbySegmentPlayback(payload) {
  return callLiveLobby("ackLiveLobbySegmentPlayback", "ackLiveLobbySegmentPlaybackV2", payload);
}

export async function leaveLiveLobby(payload) {
  return callLiveLobby("leaveLiveLobby", "leaveLiveLobbyV2", payload);
}

export async function endLiveLobby(payload) {
  return callLiveLobby("endLiveLobby", "endLiveLobbyV2", payload);
}

export function getLiveLobbyShutdownLabel(reason) {
  switch (reason) {
    case "storage_limit_reached":
      return "Team storage quota reached";
    case "monthly_upload_limit_reached":
      return "Team upload quota reached";
    default:
      return "Quota limit reached";
  }
}

export function getLiveLobbyStatusLabel(status) {
  switch (status) {
    case "starting":
      return "Starting";
    case "live":
      return "Live";
    case "quota_shutdown_grace":
      return "Ending Soon";
    case "finalizing":
      return "Finalizing";
    case "finalized":
      return "Finalized";
    case "ended":
      return "Ended";
    case "failed":
      return "Failed";
    default:
      return "Live Lobby";
  }
}
